// extracted by mini-css-extract-plugin
module.exports = {"container":"BrowserLayout_container__2RKbF","content":"BrowserLayout_content__3DDG5","browser":"BrowserLayout_browser__1oB-R","pane":"BrowserLayout_pane__jdQaS"};